export const isDesktopApp =
  typeof window !== 'undefined'
    ? navigator?.userAgent?.includes('MoisesDesktop')
    : false
